import React from 'react';

const ReadonlyFormGroup = ({label, value}) => {
    return (
        <div className="form-group">
            <label className="control-label col-md-4">
                {label}
            </label>
            <div className="col-md-8">
                <div className="form-control-static">{value}</div>
            </div>
        </div>
    );
}

export default ReadonlyFormGroup;